<template>
  <div class="supplier_audit" v-loading="loading">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="supplierName" placeholder="请输入供应商名称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
      <el-select v-model="status" placeholder="选择审核状态" @change="onSearch" clearable>
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>

    <div class="g_table">
      <!-- <el-table :data="tableData" style="width: 100%" max-height="540" :row-class-name="rowBackground"> -->
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column prop="number" label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column prop="supplierName" label="供应商名称" width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contacts" label="联系人" width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="telphone" label="联系电话" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="供应商简介" width="220" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="desc">{{ scope.row.supplierIntroduce }}</span>
          </template>
        </el-table-column>
        <el-table-column label="营业执照" min-width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="show_img" @click="previewImage(scope.row.busiLicense)">预览图片</span>
          </template>
        </el-table-column>
        <el-table-column prop="creditCode" label="统一社会信用代码" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column label="审核状态" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" style="color: red">待审核</span>
            <span v-if="scope.row.status == 1">审核通过</span>
            <span v-if="scope.row.status == 2">审核不通过</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" fixed="right" width="100">
          <template slot-scope="scope">
            <el-button class="btn" :type="scope.row.status == 0 ? 'primary' : ''" size="small" plain @click="showDetail(scope.row)">{{ scope.row.status == 0 ? "审核" : "查看" }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false
        }
      "
      :url-list="imgList"
    ></el-image-viewer>
  </div>
</template>

<script>
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      loading: false,
      supplierName: "",
      status: "",
      options: [
        { value: "0", label: "待审核" },
        { value: "1", label: "审核通过" },
        { value: "2", label: "审核不通过" },
      ],
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）

      // 图片预览
      showViewer: false,
      imgList: [],
    }
  },
  created() {
    this.getSupplierList()
  },
  methods: {
    // 供应商列表
    getSupplierList() {
      this.loading = true
      this.$axios
        .get(this.$api.supplierInfoSupplierAuditPageList, {
          params: {
            status: this.status,
            supplierName: this.supplierName,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          this.tableData = res.result.list
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 表格行未读时的背景色
    rowBackground(e) {
      if (e.row.updateStatus == 0) {
        return "unread"
      }
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getSupplierList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getSupplierList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getSupplierList()
    },
    // 查看 or 审核
    showDetail(row) {
      this.$router.push({ path: "/supplier/detail/supplierDetail", query: { id: row.supplierId, audit: 1, status: row.status } })
    },
    // 图片预览
    previewImage(url) {
      this.imgList[0] = url
      this.showViewer = true
    },
  },
}
</script>

<style scoped lang="scss">
.supplier_audit {
  .show_img {
    color: #069bbc;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  ::v-deep .unread {
    background-color: rgb(255, 227, 231) !important;
  }
}
</style>
